module.exports = __webpack_public_path__ + "img/portfolio.748138ad.png";